export const componentContainerStyle = {
    marginRight: 28,
    height: '100%'
};

export const componentContentStyle = {
    margin: '0px 20px'
};